import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import type { ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "light" } = useTheme(); // TODO: use system theme

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			className="toaster group"
			position="top-right"
			closeButton
			richColors
			duration={3000}
			toastOptions={{
				classNames: {
					closeButton: "!-right-3 !left-auto",
				},
				style: {
					"--normal-bg": "var(--popover)",
					"--normal-text": "var(--popover-foreground)",
					"--normal-border": "var(--border)",
				} as React.CSSProperties,
			}}
			{...props}
		/>
	);
};

export { Toaster };
